<template src="./registration.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'
import agTableComp from '@/optionData/agTableComp'
import M from 'minimatch'
export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">선택</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName? this.params.colDef.headerName : null
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
    name: "albumRegistration",
    data() {
      return {
        ko : ko,
        startDate :null,
        endDate : null,
        dateType :'release_date' ,
    
        dateOption : [
            {value: 'release_date',label: '발매일',},
      
        ],
        contractList : [],
        selectContract : [],
        description : null,
        keywordOption :[
            {value: 'email', label:'Email ID'},
            {value: '_name', label:'권리자명'},
            {value: 'name', label:'앨범명'},
            {value: 'company', label: '회사명'},
            {value: 'album_ref',label: '자사앨범코드'},
            {value: 'barcode',label: 'UPC',},
            {value: 'artist',label: '아티스트명',},
            {value: 'artist_english',label: '아티스트명(영문)',},
            {value: 'name_english',label: '앨범명(번역)',},
        ],

        batchType : 'insert',
        defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: false,
            rowSelection:'single'
        },
        albumList : {
          keywordType : null,
          keyword : null,
          listData: [],                 
          pageSize: 5,                 
          currentPage: 1,
          total: 0,
          totalPage: 0,
          gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
            context: {
                componentParent: this
            },
            frameworkComponents : {
              ...agTableComp
            }
          },
          columnDefs : [
            {headerName: '선택',  field: 'release_date',  filter: false,width: 130,
              cellRendererParams: {
                clicked: function(data) {
                  let insert = { 
                    ...data,
                    ej_action : this.context.componentParent.batchType
                  }
                  const a = this.context.componentParent.selectAlbum.listData
                  const idx = a.findIndex((item) => {return item.id === data.id})
                  if(idx < 0){
                    this.context.componentParent.selectAlbumId[this.context.componentParent.batchType].unshift(data.id)
                    this.context.componentParent.selectAlbum.listData.unshift(insert)
                    this.context.componentParent.selectAlbumAll.unshift(data.id)
                    this.context.componentParent.albumList.gridOptions.api.setRowData(this.context.componentParent.albumList.listData)
                  }else{
                    this.context.componentParent.noti('이미 추가된 앨범입니다.','warning')
                  }
                  
                  
                }
              },
              cellRendererSelector: (data) => {
                if(this.selectAlbumAll.indexOf(data.data.id)<0){
                  return { 
                    component: 'btnSelect',
                    params: {
                      ...data.data,
                    }
                  } 
                }else{
                  return { 
                    component: 'textRender',
                    params: {
                      text : '선택완료',
                      style : 'text-align:center; width: 80px;',
                      ...data.data,
                    }
                  }
                }
                
              }
            },
             {headerName: '상태',  field: 'state',  filter: false,width: 100, cellRenderer: (data) => {
                    let dd = {
                        temporary :'임시저장',
                        registration_complete : '접수', 
                        registration_canceled : '유통 취소', 
                        inspection_complete : '검수 완료', 
                        distribution_complete : '유통 완료', 
                        release_complete : '발매 완료', 
                        suspended : '유통중단', 
                        rejected : '반려',
                        trash : '임시삭제'
                    }
                    let color = {
                        temporary : "#9544d0b3",//'임시저장',
                        registration_complete : '#262c49',//'접수', 
                        registration_canceled : '#797979',//'유통 취소', 
                        inspection_complete : '#4092ff',//'검수 완료', 
                        distribution_complete : '#ff9f43',//'유통 완료', 
                        release_complete : '#24c1a0',//'발매 완료', 
                        suspended : '#b8c2cc',//'유통중단', 
                        rejected : '#ea5455',//'반려' 
                        trash : "#737373"
                    }
                return `
                <div class="con-vs-chip vs-chip-primary con-color" 
                style="
                    background-color: ${color[data.value]} !important;
                    color:#fff;
                    line-height:1;
                    padding:3px 5px;
                    margin:13px 0; 
                    font-size:13px;
                    min-width:50px;
                ">
                    <span style="margin:0" class="text-chip vs-chip--text">
                    ${dd[data.value]}
                </span><!----></div>`
                }},
            {headerName: '발매일',  field: 'release_date',  filter: false,width: 150,
            cellRenderer: (data) => {
              return this.fixDate(data.value, 'yyyy-MM-dd')
            }},
            {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 150},
            {headerName: 'UPC', field: 'barcode', filter: false,width: 150},
            {headerName: '앨범명', field: 'name', filter: false,width: 250,},
            {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
              cellRenderer: (data) => {
                let t = data.value
                let text =  ''
                for ( var i in t ){
                  if(i != 0){
                    text += ', '
                  }
                  text += t[i].display_name
                  
                }
                return text
            }},
            {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
            {headerName: 'Email ID', field: 'licensor.user.email', filter: false,width: 220,},
          ],
        },
        selectAlbum : {
          listData: [],                 
          pageSize: 10,                 
          currentPage: 1,
          totalPage: 0,
          gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
            context: {
                componentParent: this
            },
            frameworkComponents : {
              ...agTableComp
            }
          },
          columnDefs : [
            {headerName: '삭제',  field: 'release_date',  filter: false,width: 130,
              cellRendererParams: {
                clicked: function(data) {
                  const a = this.context.componentParent.selectAlbum.listData
                  const b = this.context.componentParent.selectAlbumId[data.ej_action]
                  const idx = a.findIndex((item) => {return item.id === data.id})
                  this.context.componentParent.selectAlbum.listData.splice(idx,1)
                  const idx2 = b.findIndex((item) => {return item === data.id})
                  this.context.componentParent.selectAlbumId[data.ej_action].splice(idx2,1)
                  this.context.componentParent.selectAlbumAll.splice(this.context.componentParent.selectAlbumAll.indexOf(data.id),1)
                  this.context.componentParent.albumList.gridOptions.api.setRowData(this.context.componentParent.albumList.listData)
                }
              },
              cellRendererSelector: (data) => {
                return { 
                  component: 'btnSelect',
                  params: {
                    ...data.data,
                    title : '삭제',
                    color:'danger'
                  }
                }
              }
            },
            {headerName: 'Batch Action', field: 'ej_action', filter: false,width: 120,cellRenderer: (data) => {
                //      success, error, is_delivering,await_delivery, temporary , is_packaging , await_packaging
                
                let color = {
                    'insert' : '#239351',
                    'update' : '#a412b5',
                    'takedown' : '#f9383f',
                    'await_delivery' : '#a457ad',
                    'temporary' : '#545353',
                    
                    'await_packaging':'#529adb',
                  }
                  
                return `<div class="cellCenter"><span class="textCenter" style=" min-width:80px; color:#fff; padding: 3px 8px; border-radius:8px; color : ${color[data.data.ej_action]}">${data.value}</span></div>`
               }
              
            },
            {headerName: '발매일',  field: 'release_date',  filter: false,width: 120,
            cellRenderer: (data) => {
              return this.fixDate(data.value, 'yyyy-MM-dd')
            }},
            {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 120},
            {headerName: 'YT', field: 'youtube_at', filter: false,width: 100,
             cellRendererParams: {
                  clicked: function(data) {
                  },
              },
              cellRendererSelector: (data) => {
                  let html = ``;
                  if(data.data.youtube_at){
                    html += `
                          <span class="textCenter" style="margin-right:3px; min-width:40px; color:#fff; padding: 3px 5px; border-radius:8px; background : #288dda">AT</span>
                    `
                  }else{
                    html += `
                        <span class="textCenter" style="margin-right:3px; min-width:40px; color:#fff; padding: 3px 5px; border-radius:8px; background : #838383">AT</span>
                    `
                  }
                  if(data.data.youtube_sr){
                    html += `
                        <span class="textCenter" style=" min-width:40px; color:#fff; padding: 3px 5px; border-radius:8px; background : #e1a627">SR</span>
                    `
                  }else{
                    html += `
                          <span class="textCenter" style=" min-width:40px; color:#fff; padding: 3px 5px; border-radius:8px; background : #838383">SR</span>
                    `
                  }
                  let dd={
                        component: 'textButton',
                        params: {
                            ...data.data,
                            text: `
                              ${html}
                            `,
                        }
                    } ;
                  // if(this.selectTrack.track_id ==  data.data.track_id ){
                  //     dd.params['disabled'] = true
                  //     dd.params['title'] = '선택완료'
                  // }
                  
                  return dd
              }
            },
            {headerName: '앨범명', field: 'name', filter: false,width: 250,},
            {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
              cellRenderer: (data) => {
                let t = data.value
                let text =  ''
                for ( var i in t ){
                  if(i != 0){
                    text += ', '
                  }
                  text += t[i].display_name
                  
                }
                return text
            }},
            {headerName: '트랙수', field: 'track_count', filter: false,width: 100,},
            {headerName: 'Email ID', field: 'licensor.user.email', filter: false,width: 220,},
          ],
        },
        selectAlbumAll : [],
        selectAlbumId :{
          insert : [],
          update : [],
          takedown : [],
        },
        upcCheck : false,
        upcText : null,
        upcCheckResult:{},
      }
    },
    mounted(){
      this.getContract()
      this.$nextTick(function(){
        
      })
    },
    computed: {
      
    },
    watch:{
      'albumList.currentPage'(){
        this.albumCall()
      }
     
    },
    methods: {
      getContract(){
        let payload = {
          sort : 'created_at',
          sortorder: 'desc',
          page: 0 ,
          limit: 50,
        }
        this.$store.dispatch('GET_DDEX_CONTRACT', payload)
        .then(result =>{
            this.loadingHide()
            this.contractList  = result.items // 권리자 목록
            for(let i in this.contractList) {
              if(this.contractList[i].is_default){
                this.selectContract.push(this.contractList[i].id)
              }
            }
            
            //페이지 수
        }).catch(error=>{
            this.loadingHide()
            const status = error.status
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                this.alert({msg : error.response.data.message})
                break;
            }
        })
      },
      getAlbumList(){
        this.albumList.currentPage = 1
        this.albumCall()
      },
      albumCall(){
        const payload = {
          sortorder: 'desc,desc',
          page: this.albumList.currentPage - 1,
          limit: 5,
        }
        if(!this.valCheck(this.dateType) && !this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
          payload['date_field'] = this.dateType
          payload['date_start'] = this.startDate
          payload['date_end'] = this.endDate
          if(this.dateType !== 'registered_at' ){
              payload['sort'] = this.dateType +',registered_at'
          }else{
              payload['sort'] = this.dateType
          }
        }
        if(this.albumList.keywordType && this.albumList.keywordType != '') {
          payload[this.albumList.keywordType] = this.albumList.keyword
        }
        this.loadingShow();
        this.$store.dispatch('LIST_ALBUM', payload)
        .then(result =>{
          this.loadingHide();
          this.albumList.listData  = result.items // 권리자 목록
          this.albumList.total = result.filtered
          //페이지 수
          const remainder = parseInt(result.filtered % this.albumList.pageSize) > 0? 1: 0
          this.albumList.totalPage = parseInt(result.filtered /this.albumList.pageSize) + remainder
            
        }).catch(error=>{
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
      },
      upcSearch(upc){
        return new Promise((resolve, reject) => {
          
          const payload = {
            sortorder: 'desc,desc',
            page: 0,
            limit: 5,
            barcode : upc
          }
      
        
          this.$store.dispatch('LIST_ALBUM', payload)
          .then(result =>{
            console.log(result)
            resolve(result)

          }).catch(error=>{
              const status = error.response.status
              reject("network err")
              return error
              switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                break;
              }
          })
        })

      },
      
      
      async makeSequentialCalls(array) {
        let idList = array
        this.upcCheckResult = {}
        this.loadingShow();
        for (const upc of idList) { // for...of 루프는 async/await와 잘 작동합니다.
          console.log(upc)
          try {
            const response = await this.upcSearch(upc); // 이전 호출이 완료될 때까지 기다립니다.
            const data = await response;
            console.log('응답 데이터:', data);
            
              if(data.items.length == 1){
                const a = this.selectAlbum.listData
                const idx = a.findIndex((item) => {return item.id === data.items[0].id})
                if(idx > -1){
                  this.upcCheckResult[upc] = '이미 추가된 UPC 코드입니다.'
                }else{
                  this.selectAlbumId[this.batchType].push(data.items[0].id)
                  
                  this.selectAlbum.listData.push(
                    {
                      ...data.items[0],
                      ej_action : this.batchType
                    }
                  )
                  this.upcCheckResult[upc] = '추가 성공'
                }
                
              }else if(data.items.length > 1){
                this.upcCheckResult[upc] = '해당 UPC 코드를 가지고있는 앨범이 2개이상입니다. '
              }else if(data.items.length < 1){
                this.upcCheckResult[upc] = '해당 UPC 코드를 가지고있는 앨범이 없습니다.'
              }
            
            
            // 필요하다면 다음 API 호출에 이 데이터를 사용할 수 있습니다.
          } catch (error) {
            console.error('API 호출 중 오류 발생:', error);
          }
        }
        this.loadingHide();
        let text = ''
        for ( const key in this.upcCheckResult ){
          text += `${key} : ${this.upcCheckResult[key]} <br/>`
        }
        this.alert({
          width:600,
          title : 'UPC 코드 검색 결과',
          msg:`<div class="textLeft">${text}</div>`
        })
        this.upcText = null
      },

      getUpcAlbums(){
        if(this.upcText){
          let data = this.upcText.split("\n");
          this.makeSequentialCalls(data)
        }
        
      },
      postDDEX(data){
        let payload = {
          params : {
            ...this.selectAlbumId,
            "export_contract_ids": this.selectContract,
            memo : this.description,
            autostart : data === 'autostart' ? true : false
          }
        }
      
        if(this.selectContract.length <  1){
          this.alert({msg:'계약사를 1개이상 선택해주세요.'})
          return false
        }
        this.loadingShow();
        this.$store.dispatch("POST_DDEXJOB", payload)
        .then(result =>{
          this.loadingHide();
          this.noti('앨범이 정상적으로 등록 되었습니다.')
          this.$router.push({path: '/ddex/job'})
        }).catch(error =>{
          this.loadingHide();
          switch(error.response.data.code) {
            default:
              this.alert({
                msg: error.response.data.message,
              })
              break;
          }
        })
      },
    },
    
}
</script>

<style scoped>

</style>